import DomComponent from './dom-component.js';


export default class ListManager extends DomComponent 
{

	constructor(options = {})
	{
		const defaults = {
			container:'.index-container'
		}

		let settings = { ...defaults, ...options }
		
		super(settings);
		
		this.deletors = [];
	}

	addDeletor(name, deletor)
	{
		if (typeof name !== 'string') {
			throw new Error('Name must be a string');
		}
		
		deletor.setManager(this).bindEvents();
		this.deletors.push({name, deletor});
		return this;
	}

	deletor(name)
	{
		const matches = this.deletors.filter(d => d.name === name);
		if (!matches.length) {
			throw new Error('Deletor not found');
		}
		return matches[0]['deletor'];
	}


	addFilters(filters) 
	{
		this.filters = filters;
		this.filters.setManager(this);
		return this;
	}


	hasFilters() 
	{
		return this.filters !== undefined;
	}


	updateResults()
	{
		if (this.hasFilters()) {
			// Manually submit the form
			this.filters.$el('container').closest('form').submit();
		} else {
			window.location.reload();
		}
	}

}